// extracted by mini-css-extract-plugin
module.exports = {"page":"page__ZLY3V","page-header":"page-header__1FaE_"};